import PlanningTimeline from '@/models/PlanningTimeline';

class WorkingView {
  constructor(data) {
    this.id = data.id;
    this.title = data.title || "";
    this.planning_id = data.planning_id;
    this.config = {
      timeline: ! Array.isArray(data.config.timeline) && data.config.timeline || {}, // convert [] to {} (correct php saving {} as [])
      lanes: data.config.lanes || [],
      elementsColors: data.config.elementsColors || [],
      elementsIcons: data.config.elementsIcons || [],
      elementsUsers: ! Array.isArray(data.config.elementsUsers) && data.config.elementsUsers || {},
      selectedDisplay: ! Array.isArray(data.config.selectedDisplay) && data.config.selectedDisplay || {},
    };
    this.meta = {
      read_only_token: data.read_only_token || null,
    };
    if (data.config.customFields) this.config.customFields = data.config.customFields;
  }

  /** GET */
  getElementsColors() {
    return this.config.elementsColors;
  }

  getElementsIcons() {
    return this.config.elementsIcons;
  }

  getLanes() {
    return this.config.lanes;
  }

  getSelectedDisplay() {
    return this.config.selectedDisplay;
  }

  getTimeline() {
    return this.config.timeline;
  }

  getElementsUsers() {
    return this.config.elementsUsers;
  }

  getCustomFields() {
    return this.config.customFields;
  }

  /** GET CALCULATED PROPERTIES */
  getElConfig(el) {
    const { description, checklist, progress, step, users, dates, links, budgets } = this.getSelectedDisplay();
    return {
      ...el.getConfig(),
      'show-description': typeof description == 'boolean' ? description : el.getConfig('show-description'),
      'show-dates': typeof dates == 'boolean' ? dates : el.getConfig('show-dates'),
      'show-progress': typeof progress == 'boolean' ? progress : el.getConfig('show-progress'),
      'show-step': typeof step == 'boolean' ? step : el.getConfig('show-step'),
      'show-checklist': typeof checklist == 'boolean' ? checklist : el.getConfig('show-checklist'),
      'show-users': typeof users == 'boolean' ? users : el.getConfig('show-users'),
      'show-links': typeof links == 'boolean' ? links : el.getConfig('show-links'),
      'show-budgets': typeof budgets == 'boolean' ? budgets : el.getConfig('show-budgets'),
    };
  }

  /** SAVE */
  save() {
    if (! this.id) return Promise.reject(new Error("unsaved view"));
    return window.apiSrv.call('views', 'update', this);
  }

  /** DELETE */
  delete() {
    if (! this.id) return Promise.reject(new Error("unsaved view"));
    return window.apiSrv.call('views', 'destroy', this);
  }

  /** APPLY WORKING VIEWS */
  applyWorkingView(planning, { isSubproject = false } = {}) {
    /* This function has an equivalent in PlanningViewController.php (applyWorkingView)
       Any change here should be reported there too.
    */
    // Lanes
    const workingViewLanesIds = new Set(_.intersection(this.getLanes(), planning.lanes.map(item => item.id)));
    planning.lanes.forEach((lane) => {
      lane.filteredout = false;
      if (workingViewLanesIds.size && ! isSubproject) { // do not filter subproject lanes
        if (! workingViewLanesIds.has(lane.id)) lane.filteredout = true;
      }
    });

    // Elements
    planning.elements.forEach((el) => {
      // setConfig with this.getSelectedDisplay() is handled in PlanningElementView.vue using getElConfig()

      el.filteredout = false;
      if (this.getElementsColors().length && ! this.getElementsColors().some(x => x.color === el.getColorId() && x.colorShade === el.getColorShadeId())) {
        el.filteredout = true;
      } else if (this.getElementsIcons().length && ! this.getElementsIcons().includes(el.getIconId())) {
        el.filteredout = true;
      } else if (this.getCustomFields() && Object.entries(this.getCustomFields()).some(([dataField, value]) => value && ! el.getCustomField(dataField)?.includes(value))) {
        el.filteredout = true;
      } else {
        const { selectedCompanyUsers = [], selectedVirtualParticipants = [], unassigned = false } = this.getElementsUsers();
        const allSelectedUsers = new Set(selectedCompanyUsers.concat(selectedVirtualParticipants));
        if (allSelectedUsers.size || unassigned) {
          const elUsers = el.getUsers();
          if (elUsers && elUsers.some(user => ! user.group_id)) { // exclude groups from considered users
            if (! elUsers.find(user => allSelectedUsers.has(user.id || user.username))) el.filteredout = true;
          } else if (! unassigned) {
            el.filteredout = true;
          }
        }
      }
    });
    planning.timeline = new PlanningTimeline(this.getTimeline());
    planning.workingView = this;
  }

  static applyLastSavedProjectVersion(planning) {
    // Lanes
    planning.lanes.forEach((lane) => {
      lane.filteredout = false;
    });

    // Elements
    planning.elements.forEach((el) => {
      el.filteredout = false;
    });
    const { timeline } = planning.lastSavedProjectVersion.content;
    planning.timeline = new PlanningTimeline(timeline);
    planning.workingView = null;
  }
}

export default WorkingView;
